// src/api/qa/useGenerateSampleInvoice.ts
import useMutationApi from 'src/api/useMutationApi';

interface ApiResponse {
  url: string;
}

const useGenerateSampleInvoice = () => {
  return useMutationApi<{ orderId: string }, ApiResponse>({
    endpoint: 'qa/create-sample-invoice-pdf',
    method: 'POST',
  });
};

export default useGenerateSampleInvoice;
